import { render, staticRenderFns } from "./RoleGeneral.vue?vue&type=template&id=1d1bd460"
import script from "./RoleGeneral.vue?vue&type=script&lang=js"
export * from "./RoleGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports